import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Settings } from '@model/settings';
import { AnalyticsService } from '@service/analytics.service';
import { SettingsCookieService } from '@service/settings-cookie.service';

@Component({
  selector: 'svnl-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
})
export class CookiesComponent implements OnInit {
  cookiesForm: FormGroup;
  settings: Settings;

  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<CookiesComponent>,
    private readonly formBuilder: FormBuilder,
    private readonly analyticsService: AnalyticsService,
    private readonly settingsCookieService: SettingsCookieService,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
    this.settings = this.settingsCookieService.getCookieSettings();
    if (this.settings === null) {
      this.settings = {};
      this.settings.tracking = true;
      this.settings.show = true;
      this.settings.marketing = true;
      this.settings.functional = true;
    }
    this.cookiesForm.get('settingsTracking').setValue(this.settings.tracking);
    this.cookiesForm.get('settingsMarketing').setValue(this.settings.marketing);
  }

  save(): void {
    this.settingsCookieService.setCookieSettings(this.settings);
    this.analyticsService.updateSettings(this.settings);
    this.settings.show = false;
    this.bottomSheetRef.dismiss();
  }

  marketingChanged(event: MatSlideToggleChange): void {
    this.settings.marketing = event.checked;
  }

  trackingChanged(event: MatSlideToggleChange): void {
    this.settings.tracking = event.checked;
  }

  private createForm(): void {

    this.cookiesForm = this.formBuilder.group({
      settingsFunctional: { value: true, disabled: true },
      settingsMarketing: false,
      settingsTracking: false,
    });
  }

}
